import { Typography, Alert } from '@mui/material';
import ConfirmFetchDialog from './components/ConfirmFetchDialog';
import FetchCompaniesSection from './components/FetchCompaniesSection';
import TallyCompanyList from './components/TallyCompanyList';
import VendorDetailsDialog from './components/VendorDetailsDialog';
import { useTally } from '../../../lib/hooks/useTally';
import ProgressDisplay from './components/ProgressDisplay';

const TallyCompanyImport = () => {
  const {
    state,
    handleFetchCompanies,
    handleFetchVendorDetails,
    handleCloseVendorDialog,
    handleFetchDetails,
    handleConfirmFetch,
    handleCloseConfirmDialog,
    handleEditGst,
    handleSaveGst,
    handleCancelEditGst,
    handleGstChange,
    handleAddCompany,
    handleSaveVendors,
    handleDownloadCorruptedVendors,
  } = useTally();

  const {
    companies,
    loading,
    error,
    openConfirmDialog,
    selectedCompany,
    openVendorDialog,
    currentVendors,
    fetchingVendors,
    vendorFetchError,
    progress,
  } = state;

  return (
    <div className="container mx-auto py-8 px-4">
      <Typography variant="h4" sx={{ color: 'black', fontWeight: '600' }}>
        Import Companies from Tally
      </Typography>
      <FetchCompaniesSection
        loading={loading}
        error={error}
        onFetchCompanies={handleFetchCompanies}
      />
      <TallyCompanyList
        companies={companies}
        onFetchDetails={handleFetchDetails}
        onAddCompany={handleAddCompany}
        onEditGst={handleEditGst}
        onSaveGst={handleSaveGst}
        onCancelEditGst={handleCancelEditGst}
        onGstChange={handleGstChange}
        onFetchVendorDetails={handleFetchVendorDetails}
        onDownloadCorruptedVendors={handleDownloadCorruptedVendors}
      />

      {fetchingVendors && progress && (
        <ProgressDisplay
          progress={progress.percentage}
          message={progress.message}
          processedVendors={progress.processedVendors}
          totalVendors={progress.totalVendors}
          processedVoucherTypes={progress.processedVoucherTypes}
          totalVoucherTypes={progress.totalVoucherTypes}
        />
      )}

      {vendorFetchError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {vendorFetchError}
        </Alert>
      )}

      <ConfirmFetchDialog
        open={openConfirmDialog}
        selectedCompany={selectedCompany}
        onConfirm={handleConfirmFetch}
        onClose={handleCloseConfirmDialog}
      />

      <VendorDetailsDialog
        open={openVendorDialog}
        onClose={handleCloseVendorDialog}
        vendors={currentVendors}
        onSaveVendors={handleSaveVendors}
      />
    </div>
  );
};

export default TallyCompanyImport;
